import AfCoreRequest from '../../../bootstrap/redux-data/AfCoreRequest';
import { IApiErrorType } from 'App/types/BaseTypes';
import serverErrorMap from '../components/Registration/serverErrorMap';

const RegistrationService = {

	/**
	 * Allows the calling of an event
	 *
	 * @param event
	 * @param eventProps
	 */
	sendRegistrationData (
		data: NewAccountData, 
		callbk:(response: IAccountLoginType) => void, 
		errorCallbk: (error: string) => void) {

		const afCoreRequest = new AfCoreRequest('registrationPage');

		afCoreRequest.postRequest({
			url: '/api/public/v1/register',
			body: data,
		} as IRequestObject).then((res: any) => {

			const response = res.getContent();

			if (callbk) {
				callbk(response);
			}

		}).catch((error: IApiErrorType) => {

			const errStatus = (error[0] && error[0].status) ? error[0].status : (error.status) ? error.status : '';
			const err = (serverErrorMap[errStatus]) ? serverErrorMap[errStatus] : 'Nicht erfolgreich';

			if (errorCallbk) {
				errorCallbk(err);
			}
		});
	}
};

export default RegistrationService;
